module.exports = __webpack_public_path__ + "static/media/location-car-icon.0d6a7c47.svg";